module.exports = __webpack_public_path__ + "media/images/pic/compare/before-27cc57746228d15047ae8c0ab4d4b9e6.jpg";